import React, { useEffect, useState } from 'react';
import { MdMessage, MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { useSelector } from 'react-redux';
import { checkUserId, delay, getThemeMode, getTimeDifference, truncateString } from '../../../../../utils/helper';
import PreChat from '../../../../preChat';
import ChatFullScreenButton from '../../../../chatFullScreenButton';

function Message({ setActiveWidget, onFormSubmit }) {
  const { widgetConfig, recentMessage, isSessionAvailable } = useSelector((state) => ({
    widgetConfig: state.messages.widgetConfig,
    recentMessage: state.messages.recentMessage,
    isSessionAvailable: state.messages.isSessionAvailable
  }));
  
  const [isBgLight, setIsBgLight] = useState(false);
  
  useEffect(() => {
    if(widgetConfig?.config?.widgetId) {
      setIsBgLight(getThemeMode(widgetConfig?.widgetConfig?.lookAndFeel?.backgroundColor))
    }
  }, [widgetConfig])

  const handleStartNewChat = () => {
    if(navigator?.onLine){
      setActiveWidget('ChatBot');
    } else {
      alert("Please check your internet connection and try again")
    }
  }

  const handleRecentMessage = () => {
    // const event = new CustomEvent("restoreChatMessages", {
    //   detail: "Button was clicked!",
    // });
    // window.dispatchEvent(event);
    // delay(500);
    setActiveWidget('ChatBot')
  }

  return (
    <>
      <div className='rcw-message-tab'>
        <ChatFullScreenButton isBgLight={isBgLight} />
        <div className='rcw-message-header' style={{ background: widgetConfig?.widgetConfig.lookAndFeel?.backgroundColor }}>
          <div className='rcw-message-title' style={{ color: isBgLight ? '#000000' : '#ffffff' }}>Messages</div>
        </div>
        <div className='rcw-message-body'>
          {isSessionAvailable ? <ul className='rcw-messages-list'>
            <li>
              <div className="conversation-list-item" role="button"  onClick={() => handleRecentMessage()}>
                <div className="image-icon">
                  <img src="./images/receiver-msg.svg" alt="Profile image for Tess" />
                </div>
                <div className="message-content">
                  <div className="">
                    <div className="">
                      <span className="">{truncateString((recentMessage?.content?.data ? recentMessage?.content?.data[0]?.message?.content?.text : recentMessage?.content?.text) ?? '', 40)}</span>
                    </div>
                    <div className="timestamp">
                      <div className="">Bot &nbsp;</div>
                      <div> • {getTimeDifference(recentMessage?.content?.data ? recentMessage?.content?.data[0]?.message?.timeStamp : recentMessage?.timeStamp)}</div>
                    </div>
                  </div>
                </div>
                <div className="">
                  <div className="">
                    <i color="linkColor" size="16" className="">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M5.42773 4.70898C5.46387 4.85254 5.53809 4.98828 5.65039 5.10059L8.54932 8L5.64893 10.9004C5.31689 11.2324 5.31689 11.7705 5.64893 12.1025C5.98096 12.4336 6.51904 12.4336 6.85107 12.1025L10.3516 8.60059C10.5591 8.39355 10.6367 8.10449 10.585 7.83691C10.5537 7.67578 10.4761 7.52246 10.3516 7.39844L6.85254 3.89941C6.52051 3.56738 5.98242 3.56738 5.65039 3.89941C5.43066 4.11816 5.35645 4.42871 5.42773 4.70898Z" fill="currentColor"></path>
                      </svg>
                    </i>
                  </div>
                </div>
              </div>
            </li>
          </ul> : 
          <>
            {widgetConfig?.widgetConfig?.preChatSurvey?.display ? 
            <div className='rcw-message-prechat'>
              <PreChat data={widgetConfig?.widgetConfig?.preChatSurvey} onFormSubmit={onFormSubmit} buttonColor={widgetConfig?.widgetConfig.lookAndFeel?.backgroundColor} colors={isBgLight ? '#000000' : '#ffffff'} config={widgetConfig?.config} />
            </div> : 
            <div>
              <div className='no-message-content'>
                <MdMessage size={45} />
                <div className='title'>No messages</div>
                <div className='subtitle'>Messages from the will be shown here</div>
              </div>
              <button className='rcw-chat-button' onClick={handleStartNewChat} style={{ color: isBgLight ? '#000000' : '#ffffff', background: widgetConfig?.widgetConfig.lookAndFeel?.backgroundColor, border: widgetConfig?.widgetConfig.lookAndFeel?.backgroundColor === "#ffffff" ? '1px solid #dddddd' : '' }}>Start New Chat</button>
            </div>
          }
          </>}
          
        </div>
      </div>
    </>
  );
}

export default Message;
